import _extends from '@babel/runtime-corejs3/helpers/extends';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { TUXSeparator } from '../TUXSeparator/TUXSeparator.js';
import { _TUXBaseDialog } from './_TUXBaseDialog.js';
import { TUXDialogButtonAction, TUXDialogTextAction } from './TUXDialogAction.js';
import { TUXDialogImage } from './TUXDialogImage.js';

var _ref3 = /*#__PURE__*/React.createElement(TUXSeparator, {
  size: "medium",
  color: "LineSecondary"
});

var TUXDialog = function TUXDialog(props) {
  var _props$isVisible = props.isVisible,
      isVisible = _props$isVisible === void 0 ? false : _props$isVisible,
      image = props.image,
      _props$hasCloseButton = props.hasCloseButton,
      hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton,
      closeButtonColor = props.closeButtonColor,
      title = props.title,
      message = props.message,
      accessory = props.accessory,
      onDismiss = props.onDismiss,
      getContainer = props.getContainer;

  var _ref = /*#__PURE__*/React.createElement("div", {
    className: "H2-Bold px-20 text-color-TextPrimary mb-12"
  }, title);

  var _ref2 = /*#__PURE__*/React.createElement("div", {
    className: "mt-20"
  }, accessory);

  var TUXDialogContent = function TUXDialogContent() {
    var direction = 'horizontal';

    if (props.actionVariant === 'button' || props.actions.length >= 3) {
      direction = 'vertical';
    } else if (props.actionDirection !== undefined) {
      direction = props.actionDirection;
    }

    var isActionHorizontal = direction === 'horizontal';
    var hasTitle = title !== undefined;
    var isIconImage = image !== undefined ? image.variant === 'icon' : false;
    return /*#__PURE__*/React.createElement("div", {
      className: "tux-dialog__content-container background-color-BGTertiary text-color-TextPrimary flex flex-col"
    }, image ? /*#__PURE__*/React.createElement("div", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement(TUXDialogImage, image)) : null, /*#__PURE__*/React.createElement("div", {
      className: 'pb-20 flex flex-col text-center' + (!isIconImage ? " pt-24" : ""),
      style: {
        minHeight: 0
      }
    }, hasTitle ? _ref : null, /*#__PURE__*/React.createElement("div", {
      className: "px-20 " + (hasTitle ? 'H4-Regular text-color-TextSecondary' : 'H3-Regular text-color-TextPrimary'),
      style: {
        overflowY: 'auto'
      }
    }, message), accessory ? _ref2 : null), /*#__PURE__*/React.createElement("div", {
      className: clsx('w-full relative flex flex-shrink-0', isActionHorizontal ? 'flex-row-reverse h-48' : 'flex-col', props.actionVariant === 'button' && ['pt-2', props.actions.length > 1 && 'pb-8', props.actions.length === 1 && 'pb-16'])
    }, props.actionVariant === 'text' && props.actions.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "absolute w-full",
      style: {
        top: 0,
        left: 0
      }
    }, _ref3), useMemo(function () {
      var _context, _context2;

      return props.actionVariant === 'button' ? _mapInstanceProperty(_context = props.actions).call(_context, function (actionProps) {
        return /*#__PURE__*/React.createElement(TUXDialogButtonAction, _extends({
          key: actionProps.text + actionProps.variant
        }, actionProps));
      }) : _mapInstanceProperty(_context2 = props.actions).call(_context2, function (actionProps, idx) {
        return [/*#__PURE__*/React.createElement(TUXDialogTextAction, _extends({
          key: actionProps.text + actionProps.variant
        }, actionProps)), idx < props.actions.length - 1 ? /*#__PURE__*/React.createElement(TUXSeparator, {
          key: idx,
          size: "medium",
          color: "LineSecondary",
          direction: isActionHorizontal ? 'vertical' : 'horizontal'
        }) : null];
      });
    }, [isActionHorizontal, props.actionVariant, props.actions])));
  };

  return /*#__PURE__*/React.createElement(_TUXBaseDialog, {
    isVisible: isVisible,
    hasCloseButton: hasCloseButton,
    closeButtonColor: closeButtonColor,
    onDismiss: onDismiss,
    getContainer: getContainer
  }, /*#__PURE__*/React.createElement(TUXDialogContent, null));
};

export { TUXDialog };
//# sourceMappingURL=TUXDialog.js.map
